export function stripQuotes(str: string): string {
  return str.replace(/^"|"$/g, '');
}

// React events from a portal, such as a menu, bubble through the React tree
// but come from DOM nodes outside the element that handles them.
export function isEventFromOutsideCurrentTarget(event: ?Object): boolean {
  const { currentTarget, target } = event ?? {};
  if (!currentTarget?.contains || !target) return false;
  return !currentTarget.contains(target);
}

export const SUBMIT_SCREENING_MENU_ATTRIBUTE = 'data-submit-screening-menu';

// The Submit Screening menu sits in the accordion summary. Its clicks must
// reach the document, where the menu's click-away listener runs, so the
// accordion uses this check instead of a stopped event.
export function isEventFromSubmitScreeningMenu(event: ?Object): boolean {
  const target = event?.target;
  if (typeof target?.closest !== 'function') return false;
  return target.closest(`[${SUBMIT_SCREENING_MENU_ATTRIBUTE}]`) !== null;
}
